import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';

const s:any = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: 'spacing(1)',
    marginRight: 'spacing(1)',
  },
};

class FDateTimeField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;

  constructor(props:any) {
    super(props);
    this.state = {
      value: props.value || '',
    };
  }

  handleChange = (event:any) => {
    const { onChange } = this.props;
    const value = event.target.value;
    this.setState({ value });
    if (typeof onChange === 'function') onChange(value);
  };

  render() {
    const { id, label, required, options = {}, divider } = this.props;
    const { value } = this.state;
    const dtoptions = {
      InputLabelProps: { shrink: true },
      ...(options || {}),
    };

    return (
      <React.Fragment>
        <TextField
          label={label}
          id={id}
          name={id}
          type={'datetime-local'}
          required={required}
          margin='dense'
          fullWidth={true}
          sx={{ ...s.textField }}
          onChange={this.handleChange}
          value={value}
          {...dtoptions}
        />
        {divider && <Divider />}
      </React.Fragment>
    );
  }
}

FDateTimeField.propTypes = {
  classes: PropTypes.object,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FDateTimeField;

